module.exports = __webpack_public_path__ + "static/media/vegitables_39.7dd5e418.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_39.csv
// module id = 623
// module chunks = 0